var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleBgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 30,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.823,
    height: 28.823,
    x: 0.122,
    y: 0.677,
    fill: "#EDF2F5",
    fillOpacity: 0.5,
    rx: 14.412
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#CED5DA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.945 10.677 10.122 19.5m0-8.823 8.823 8.823"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBgClose);
export default __webpack_public_path__ + "static/media/circle-bg-close.0dc01667cf1e1f9847f0f294cab42d2a.svg";
export { ForwardRef as ReactComponent };